import gsap from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { animateObserver, maskIn, parallaxMask, fadeIn } from "../../../js/animations/animations";

(() => {
  const BRHBannerDecorative = () => {
    const init = () => {
      //== Animations
      if (!isMobile() && !isAuthor()) {
        const bannerDecorative = document.querySelectorAll(".brh-banner-decorative");
        if (bannerDecorative.length > 0) {
          bannerDecorative.forEach((element) => {
            const bannerMask = element.querySelector(".js-banner-decorative-parallax-mask");
            const image = bannerMask.querySelector(".cmp-image__image");
            const videoCover = bannerMask.querySelector(".brh-video__cover");
            !videoCover && image && parallaxMask({ classElement: image, trigger: bannerMask });
            videoCover && parallaxMask({ classElement: videoCover, trigger: bannerMask });

            const video = bannerMask.querySelector(".brh-video__player");
            video && parallaxMask({ classElement: video, trigger: bannerMask });

            const appearances = gsap.timeline();

            const texts = element.querySelectorAll(".js-banner-decorative-fadeIn");
            texts.length > 0 && appearances.add(fadeIn({ classElement: texts, duration: 2 }), 0);

            const bannerShowcaseMask = element.querySelector(".js-banner-decorative-parallax-mask");
            bannerShowcaseMask && appearances.add(maskIn({ classElement: bannerShowcaseMask }), 0);

            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHBannerDecorative);
})();
